import React from 'react';
import colors from '../../util/colors';
import {Icons} from '../../util/icons';
import Icon from '../icon';
import {Column, Row} from '../layout';
import * as fonts from '../../util/fonts';
import './styles.scss';

export interface NewErrorMessageProps {
  iconName: any;
  text: string;
  colorIcon: any;
  className?: string;
}

function NewErrorMessage({
  iconName,
  text,
  colorIcon,
  className,
}: NewErrorMessageProps) {
  return (
    <Column className={`new-error-message${className}`}>
      <Row className="justify-content-center pt-3 m-0">
        <Icon
          name={iconName}
          color={colorIcon}
          width="24"
          height="24"
          changeViewbox={false}
          viewBox={'0 0 24 24'}></Icon>
      </Row>
      <Row className="justify-content-center">
        <p
          style={{...fonts.M, color: colors.alertRed}}
          className="m-0 pt-1 ml-2 mr-2">
          {text}
        </p>
      </Row>
    </Column>
  );
}

export default NewErrorMessage;
